import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type Breadcrumb = {
  label: string
  onClick: Function
} | {
  label: string
  href: string
} | {
  label: string
}

@Component({
  host: { 'test-id': 'app-breadcrumb' },
  selector: 'app-breadcrumb',
  styleUrls: ['./breadcrumb.component.scss'],
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  breadcrumbs = input.required<Breadcrumb[]>()

  hasOnClick(breadcrumb: Breadcrumb): breadcrumb is { label: string; onClick: Function } {
    return 'onClick' in breadcrumb;
  }

  hasHref(breadcrumb: Breadcrumb): breadcrumb is { label: string; href: string } {
    return 'href' in breadcrumb;
  }

  isClickable(breadcrumb: Breadcrumb): boolean {
    return this.hasOnClick(breadcrumb) || this.hasHref(breadcrumb);
  }

  handleClick(breadcrumb: Breadcrumb): void {
    if (this.hasOnClick(breadcrumb)) {
      breadcrumb.onClick();
    } else if (this.hasHref(breadcrumb)) {
      window.location.href = breadcrumb.href;
    }
  }
}
